import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from 'react-router-dom';
// tslint:disable-next-line:no-import-side-effect
import './index.css';
import logger, { LogLevel } from './utils/Logger';
import localizer from './utils/Localizer';
import { localeEn, LOCALE_NAME_ENGLISH } from './locales/en';

logger.logLevel = LogLevel.Debug;
localizer.setLocale(LOCALE_NAME_ENGLISH, localeEn);
localizer.useFallbackLocale(LOCALE_NAME_ENGLISH);

function loadReact() {
  ReactDOM.render(
    <Router>
      <App />
    </Router>,
    document.getElementById('root'),
  );
}

loadReact();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
